// Copyright (c) 2016 Deere & Company

import * as productActions from '../../actions-list';
import * as userActions from '../../../user/actions-list';
import Facets, {getDefaultState} from '../state/facets';
import {
    sharedToggleDealerAccountFacetItems,
    sharedUpdateDealerAccountFacetInput,
    sharedUpdateDealerAccountFacetItem
} from '../../../shared/reducers/facets';

const actions = {
    ...productActions,
    ...userActions
};

const updateRequestedDateRangeFacet = (state, action) =>
    Facets.update(state, {
        requestedDateRange: {
            dateRange: {$set: action.dateRange}
        }
    });

const updateDealerAccountFacetInput = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedUpdateDealerAccountFacetInput(state.dealerAccountsFacet, action)
        }
    });

const updateTransferApprovalFacetItem = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedUpdateDealerAccountFacetItem(state.dealerAccountsFacet, action)
        }
    });

const toggleTransferApprovalFacetItems = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedToggleDealerAccountFacetItems(state.dealerAccountsFacet, action)
        }
    });

const updateFacetsOnLoad = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $merge: {
                allowedDealers: action.allowedDealers,
                displayedDealers: action.allowedDealers,
                isInitialLoad: false,
                selectedDealers: action.allowedDealers
            }
        }
    });

const resetTransferApprovalFacet = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            displayedDealers: {
                $set: action.allowedDealers
            },
            searchInput: {
                $set: ''
            },
            selectedDealers: {
                $set: action.allowedDealers
            }
        },
        requestedDateRange: {
            $set: getDefaultState().requestedDateRange
        }
    });

const updateDealers = state =>
    Facets.update(state, {
        dealerAccountsFacet: {
            isInitialLoad: {
                $set: true
            }
        }
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_TRANSFER_APPROVAL_FACETS]: resetTransferApprovalFacet,
        [actions.TOGGLE_TRANSFER_APPROVAL_FACET_ITEMS]: toggleTransferApprovalFacetItems,
        [actions.UPDATE_REQUESTED_DATE_RANGE_FACET]: updateRequestedDateRangeFacet,
        [actions.UPDATE_TRANSFER_APPROVAL_FACET_INPUT]: updateDealerAccountFacetInput,
        [actions.UPDATE_TRANSFER_APPROVAL_FACET_ITEMS_ON_LOAD]: updateFacetsOnLoad,
        [actions.UPDATE_TRANSFER_APPROVAL_FACET_ITEM]: updateTransferApprovalFacetItem,
        [actions.UPDATE_USER_PREFERENCES_ALL_DEALER_ACCOUNTS]: updateDealers,
        [actions.UPDATE_USER_PREFERENCES_DEALER_ACCOUNTS]: updateDealers
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/transfers/reducers/facets.js